import freeDomains from './freeDomains';

type FilterFreeDomains = {
  /** Checks if we should restrict the email domains. */
  shouldRestrictDomain: boolean;
  /** The current domain of the input. */
  currentDomain: string;
};

const filterFreeDomains = (input: string): FilterFreeDomains => {
  const currentDomain = input.toLocaleLowerCase().substring(input.indexOf('@'));

  return {
    shouldRestrictDomain: freeDomains.includes(currentDomain),
    currentDomain,
  };
};

export { freeDomains, filterFreeDomains };
export default filterFreeDomains;
